import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import React, { useState } from 'react';
import { components as RsComponents, GroupProps } from 'react-select';
import styled from 'styled-components';
import { Select } from 'components/atoms/select';

const Line = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-02);
`;
const Label = styled.span`
  padding: 0;
  margin-left: var(--spacing-03);
`;

const StyledGroup = styled(RsComponents.Group)`
  padding-bottom: 0;
`;

const Group = (props: GroupProps<any, false>) => {
  const { children, label, ...rest } = props;
  const [isVisible, setIsVisible] = useState(true);
  const toggleState = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <StyledGroup
      {...rest}
      label={
        <Line onClick={toggleState}>
          {isVisible ? <ChevronDown16 /> : <ChevronRight16 />}
          <Label>{label}</Label>
        </Line>
      }
    >
      {isVisible && children}
    </StyledGroup>
  );
};

export const GroupSelect = ({ options, ...rest }) => {
  return <Select options={options} components={{ Group }} {...rest} />;
};
